/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillOfMaterial } from '../../models/bill-of-material';

export interface GetBillOfMaterials$Params {
  productionOrderId: number;
}

export function getBillOfMaterials(http: HttpClient, rootUrl: string, params: GetBillOfMaterials$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BillOfMaterial>>> {
  const rb = new RequestBuilder(rootUrl, getBillOfMaterials.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BillOfMaterial>>;
    })
  );
}

getBillOfMaterials.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetBillOfMaterials';
